import {z} from 'zod'

export enum EmailTemplateStatus {
  DRAFT = 'DRAFT',
  APPROVED = 'APPROVED',
}

export const EmailTemplateListItemSchema = z.object({
  id: z.number(),
  name: z.string().max(100),
  scope: z.string().nullish(),
  status: z.string().nullish(),
  updated_on: z.string().nullish(),
  created_by: z.string().nullish(),
  active: z.boolean().nullish(),
})

export type EmailTemplateListItem = z.infer<typeof EmailTemplateListItemSchema>

export const GetEmailTemplatesRequestSchema = z.object({
  channel: z.literal('EMAIL'),
  pageNumber: z.number().optional(),
  pageSize: z.number().optional(),
  sortBy: z.string().optional(),
})
export type GetEmailTemplatesRequest = z.infer<typeof GetEmailTemplatesRequestSchema>

const EmailTemplatePaginationSchema = z.object({
  pageNumber: z.number().optional(),
  pageSize: z.number().optional(),
  totalElements: z.number().optional(),
  totalPages: z.number().optional(),
})

export const GetEmailTemplatesResponseSchema = z.object({
  content: z.array(EmailTemplateListItemSchema),
  pagination: EmailTemplatePaginationSchema,
  success: z.boolean().optional(),
  errorMessage: z.string().nullish(),
})
export type GetEmailTemplatesResponse = z.infer<typeof GetEmailTemplatesResponseSchema>

export const GetEmailTemplateByIdRequestSchema = z.void()
export const GetEmailTemplateByIdResponseSchema = z.object({
  id: z.number(),
  name: z.string().max(100),
  subject: z.string().nullish(),
  message: z.string().nullish(),
  scope: z.string().nullish(),
  status: z.string().nullish(),
  updated_on: z.string().nullish(),
  created_by: z.string().nullish(),
  active: z.boolean().nullish(),
})
export type GetEmailTemplateByIdRequest = z.infer<typeof GetEmailTemplateByIdRequestSchema>
export type GetEmailTemplateByIdResponse = z.infer<typeof GetEmailTemplateByIdResponseSchema>

export const UpdateEmailTemplateStatusRequestSchema = z.object({
  active: z.boolean(),
})
export const UpdateEmailTemplateStatusResponseSchema = z.object({
  id: z.number(),
  name: z.string(),
  message: z.string().nullish(),
  scope: z.string().nullish(),
  active: z.boolean(),
  status: z.string(),
  created_by: z.string().nullish(),
  updated_on: z.string().nullish(),
})
export type UpdateEmailTemplateStatusRequest = z.infer<typeof UpdateEmailTemplateStatusRequestSchema>
export type UpdateEmailTemplateStatusResponse = z.infer<typeof UpdateEmailTemplateStatusResponseSchema>
